module.exports = __webpack_public_path__ + "media/Meta_Content_HD_Denoised_beauty.b5b057b5.mp4";